import axios from 'axios'

const apiClient = axios.create({
    baseURL: process.env.VUE_APP_API_URL_VALIDATION,        
    timeout: 20000
})

export default {
    async feasibilityCheck(query) {        
        return await apiClient.post(`coverage`, {
            request:query
        });
    }
}